<script setup lang="ts">
import Card from "primevue/card";
</script>
<template>
    <div
        class="bg-surface-100 dark:bg-surface-950 flex min-h-screen flex-col items-center pt-6 sm:justify-center sm:pt-0"
    >
        <div>
            <slot name="logo" />
        </div>

        <Card class="mt-6 w-full sm:max-w-md">
            <template #content>
                <slot />
            </template>
        </Card>
    </div>
</template>
